import { useEffect, useState, useRef } from "react";

// local import
import "./style.scss";
import Card from "../Card/Card";
import contents from "../../utils/CardContent.js";

const categories = [
  { key: "web",      label: "Web Development",    icon: "🌐" },
  { key: "software", label: "Software Development", icon: "💻" },
  { key: "mobile",   label: "Mobile Development",   icon: "📱" },
];

const CategorySection = ({ label, icon, items }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setVisible(true); }),
      { threshold: 0.1 }
    );
    observer.observe(domRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`project-category fade-in-section ${isVisible ? "is-visible" : ""}`}
      ref={domRef}
    >
      <div className="category-header">
        <span className="category-icon">{icon}</span>
        <h3 className="category-title">{label}</h3>
      </div>
      <div className="cardsDisplay">
        <div className="cardsGrid">
          {items.map((content) => (
            <Card key={content.id} content={content} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Project = () => (
  <div className="projects-wrapper">
    {categories.map(({ key, label, icon }) => (
      <CategorySection key={key} label={label} icon={icon} items={contents[key]} />
    ))}
  </div>
);

export default Project;
